require('./promo-codes-list-container.scss')

module.exports = {
  template: require('./promo-codes-list-container.pug')()
  controller: require('./promo-codes-list-container.ctrl')
}
